import React from "react";
import {Animated} from "react-animated-css";
import {Card} from "./styleComponentes";

export const ComponenteFeature = ({titulo, subTitulo, texto, icone, status}) => {
    return (

        <Card >
            <Animated animationIn="slideInUp" animationOut="lightSpeedOut" animationInDuration={1000} animationOutDuration={1000}  isVisible={status}>
            <div>
                {icone}
            </div>
            <header>
                <h2>{titulo}</h2>
                <span>{subTitulo}</span>
            </header>
            <div>
                <p>
                    {texto}
                </p>
            </div>
            </Animated>
        </Card>
    )
};